import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Tooltip } from '@hiiretail/synergy-ui';
import { setAppVersionCookie } from '../../hooks/appVersionCookie';

// The allow-listed tenants live in nginx (config.testrunner.conf /
// config.prod.conf), not here, so this button can't drift from the
// server-side gate that actually decides whether v2 is reachable.
export const TryNewConsoleButton: React.FC = () => {
  const [v2Enabled, setV2Enabled] = useState(false);

  useEffect(() => {
    axios
      .get<{ v2Enabled: boolean }>('/console-version-config')
      .then((response) => setV2Enabled(response.data.v2Enabled))
      .catch(() => setV2Enabled(false));
  }, []);

  if (!v2Enabled) {
    return null;
  }

  const handleClick = () => {
    setAppVersionCookie();
    globalThis.location.reload();
  };

  return (
    <Tooltip title="Console v2 is right now under development and is not Production ready.">
      <Button onClick={handleClick} variant="secondary">
        Try new console
      </Button>
    </Tooltip>
  );
};
